module.exports = __webpack_public_path__ + "img/elements_graphiques-04.04692ef3.png";